/**
 * 🟥 CUADRO NEGRO API Insights v4 (feb-2026) — Transformer fetch.
 *
 * ⚠️ Latencia 3-10s (entrena Transformer 40 epochs por request).
 */
const BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export async function fetchInsightsV4(userId) {
  const res = await fetch(
    `${BASE}/api/insights/v4/predict?user_id=${encodeURIComponent(userId)}`,
    { credentials: 'include' },
  );
  return res.json();
}
